const TextArea = ({
  className,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled,
  name,
  title,
  error,
  inputStyles,
}: {
  className?: string;
  placeholder: string;
  value?: string;
  disabled?: boolean;
  name: string;
  title?: string;
  inputStyles?:string;
  error?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && event.shiftKey) {
      event.preventDefault();
      const target = event.target as HTMLTextAreaElement;
      const currentValue = target.value;
      const cursorPosition = target.selectionStart;
      const newValue = currentValue.substring(0, cursorPosition) + '\n' + currentValue.substring(cursorPosition);

      if (onChange) {
        onChange({ ...event, target: { ...target, value: newValue } } as React.ChangeEvent<HTMLTextAreaElement>);
      }

      setTimeout(() => {
        target.selectionStart = target.selectionEnd = cursorPosition + 1;
      }, 0);
    }
  };

  return (
    <div className={`space-y-2 relative font-medium ${className}`}>
      <label htmlFor={name} className="text-burntBlack ">
        {title}
      </label>
      <textarea
        className={`border-2 border-black border-opacity-40 block w-full p-4 focus:outline-none hover:border-primary resize-none hover:border-opacity-100 transition-all ease-in focus:border-secondary focus:ring-secondary/50 rounded-lg bg-white ${inputStyles}`}
        placeholder={placeholder}
        value={value}
        name={name}
        onBlur={onBlur}
        onKeyDown={handleKeyDown}
        rows={4} // Set the default row count
        
        onChange={onChange}
        disabled={disabled}
      />
      {error && <span className={`text-red-500`}>{error}</span>}
    </div>
  );
};

export default TextArea;
